module.exports = __webpack_public_path__ + "img/bg-home-persona-4.9c3980d.png";